import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory } from './types';

export const invitesDescriptor = defineNotificationCategory('invites', {
  actionUrl: (data, organizationId) =>
    `/org-id/${organizationId}/settings/user-management/users/${data.inviteeUserId}`,
  pills: () => ['Invite'],
  audience: PERMISSIONS.EDIT_ORGANIZATION,
  scope: 'account',
  defaultChannels: ['email', 'in_app', 'slack'],
});

export const workIntegrationReauthDescriptor = defineNotificationCategory(
  'work_integration_reauth',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: (data) => [data.sourceSystemType ?? 'Jira'],
    audience: PERMISSIONS.EDIT_INTEGRATIONS,
    scope: 'account',
    defaultChannels: ['email', 'in_app', 'slack'],
  },
);
